import { Fragment } from "react";
import Filter from "../Commons/Filter";
import Table from "../Commons/Table";
import { dateFormatter } from "../../lib/formatter";
import { faPlusCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styled from "styled-components";
import { TermTemplatesProps } from "../../types/termTemplates";

/* styled */
const ContentTitle = styled.div`
  position: absolute;
  top: -3.1875rem;
  right: 0;
  height: 2rem;

  @media screen and (max-width: 768px) {
    top: -2.5625rem;
  }
  @media screen and (max-width: 480px) {
    position: relative;
    top: 0;
    height: auto;
    margin-left: -1rem;
    padding: 0.625rem 1rem;
    width: 100%;
    background: #ffffff;
    border-top: 1px solid #cccccc;
  }
`;
const ContentTopButtonForm = styled.div`
  float: right;
  margin: 1.25rem auto;

  .center {
    display: block;
    padding-top: 0;

    .detail {
      right: 0;
    }
    .pl20 {
      padding-left: 1.25rem;
    }
  }
`;
const ContentButton = styled.button`
  height: 2.3rem;
  min-width: 5rem;
  padding: 0.5rem;
  border-radius: 0.35rem;
  color: #ffffff;
  font-size: 0.875rem;
  font-weight: bold;
  background-color: #044dac;
  border: 0px;
  cursor: pointer;
  box-shadow:
    0 0 1px 0 rgb(0 0 0 / 20%),
    0 2px 4px -2px rgb(0 0 0 / 30%);

  :hover {
    background-color: #4c9ffe;
  }
  :disabled {
    background-color: #949494;
    cursor: default;
  }
`;

const TermsTemplatesList = ({
  termTemplatesItems,
  filterItem,
  userRole,
  termTemplatesTotal,
  handleToggle,
  handleFilter,
  handleinitFilter,
  handleTermTemplatesDetail,
  handleTermTemplatesCreateModal,
  handleTermTemplatesDeleteModal,
}: TermTemplatesProps) => {
  return (
    <Fragment>
      <ContentTitle>
        <Filter
          columns={[
            {
              key: "room_no",
              size: "lg",
              placeholder: "약관제목",
              value: filterItem.title,
              action: handleFilter,
            },
          ]}
          init={handleinitFilter}
        />
      </ContentTitle>
      {userRole === "master" ? (
        <ContentTopButtonForm>
          <ContentButton onClick={handleTermTemplatesCreateModal}>
            <FontAwesomeIcon icon={faPlusCircle} className="icon-item-add" />
            <span>약관 추가</span>
          </ContentButton>
        </ContentTopButtonForm>
      ) : (
        <div style={{ paddingTop: "1.25rem" }}></div>
      )}
      <Table
        columns={[
          {
            key: "view",
            text: "상세보기",
            width: "8%",
            moveToPage: {
              func: handleTermTemplatesDetail,
              params: ["id"],
            },
          },
          {
            key: "title",
            text: "약관 제목",
            width: "25%",
          },
          {
            key: "language",
            text: "언어",
            width: "8%",
          },
          {
            key: "created_at",
            text: "생성일자",
            width: "20%",
            formatter: {
              func: dateFormatter,
              params: ["created_at"],
            },
          },
          {
            key: "updated_at",
            text: "수정일자",
            width: "20%",
            formatter: {
              func: dateFormatter,
              params: ["updated_at"],
            },
          },
          {
            key: "toggle",
            text: "노출 여부",
            width: "10%",
            toggle: {
              valueKey: "is_published",
              onChange: {
                func: handleToggle,
                params: ["id"],
              },
            },
          },
          {
            key: "button",
            text: "",
            width: "5%",
            items: [
              {
                text: "약관 삭제",
                action: {
                  func: (id: number, title: string) =>
                    handleTermTemplatesDeleteModal(id, title),
                  params: ["id", "title"],
                },
              },
            ],
          },
        ]}
        datas={termTemplatesItems}
        userRole={userRole}
        total={termTemplatesTotal}
      />
    </Fragment>
  );
};

export default TermsTemplatesList;
